<template>
    <div class="logobar">
        <div class="container">
            <!-- <div class="col-3 text-start d-none d-md-block mt-3">

                <div class="print-options ml-5">
                    <button
                        v-for="option in printOptions"
                        :key="option.id"
                        :class="{ active: option.active }"
                        @click="toggleOption(option.id)"
                        >
                        {{ option.label }}
                    </button>
                </div>

            </div> -->
            <router-link :to="{ name: 'Home' }" class="logo">
                <!-- <img src="/assets/favicons/favicon.svg" :alt="appName" /> -->
                <img src="/assets/img/header/header-bi.svg" :alt="appName" />
                <img src="/assets/img/header/header-logo.svg" :alt="appName" />
            </router-link>

            <!-- 상품검색, 사이트검색 -->
            <div class="search-field">
                <input type="text" ref="searchInput" placeholder="키워드를 입력해주세요." @keyup="searchByEnter" />
                <img src="/assets/img/search-icon.svg" alt="검색" @click="searchByKeyword" />
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import FullCategories from '../../../pages/custom/prione/FullCategories.vue';
    export default {
        props: {
            loading: { type: Boolean, required: true, default: true },
            data: {
                type: Object,
                default: {},
            },
        },
        components: {
            FullCategories,
        },
        data: () => ({
            openSearch: false,
            searchKeyword: '',
            printOptions: [
                { id: 'digital', label: '디지털인쇄', active: false },
                { id: 'offset', label: '옵셋인쇄', active: false },
                { id: 'largeformat', label: '실사출력', active: false },
            ],
            mobileMenu: {
                장바구니: 'mobile-cart-icon.svg',
                마이페이지: 'mobile-user-icon.svg',
            },
            isActiveMenu: false,
            currMenu: 0,
        }),
        computed: {
            ...mapGetters('app', ['appLogo', 'appName', 'banners']),
            ...mapGetters('auth', ['isAuthenticated']),
            ...mapGetters('cart', ['getCartCount']),
        },
        methods: {
            ...mapActions(['auth/logout']),
            ...mapActions('cart', ['resetCart']),
            ...mapActions('wishlist', ['resetWishlist']),
            search() {
                this.$router
                    .push({
                        name: 'Search',
                        params: this.searchKeyword.length > 0 ? { keyword: this.searchKeyword } : {},
                        query: {
                            page: 1,
                        },
                    })
                    .catch(() => {});
            },
            async logout() {
                const res = await this.call_api('get', 'auth/logout');
                this['auth/logout']();
                this.resetCart();
                this.resetWishlist();
                //this.$router.push({ name: "Home" }).catch(() => {});
                window.location.href = '/';
            },
            toggleSearch(status) {
                this.openSearch = status;
            },
            toggleOption(id) {
                if (this.activeOption !== id) {
                    this.printOptions.forEach((option) => {
                        option.active = option.id === id;
                    });
                    this.activeOption = id;
                }

                if (id == 'digital') {
                    this.$router.push({ name: 'AllDigitalPrinting' });
                } else if (id == 'offset') {
                    this.$router.push({ name: 'AllOffsetPrinting' });
                } else if (id == 'largeformat') {
                    this.$router.push({ name: 'AllLargeformatPrinting' });
                } else {
                    this.$router.push({ name: 'AllDigitalPrinting' });
                }
            },
            toggleInit() {
                if (this.$route.name === 'AllDigitalPrinting') {
                    this.printOptions[0].active = true;
                    this.printOptions[1].active = false;
                    this.printOptions[2].active = false;
                } else if (this.$route.name === 'AllOffsetPrinting') {
                    this.printOptions[0].active = false;
                    this.printOptions[1].active = true;
                    this.printOptions[2].active = false;
                } else if (this.$route.name === 'AllLargeformatPrinting') {
                    this.printOptions[0].active = false;
                    this.printOptions[1].active = false;
                    this.printOptions[2].active = true;
                }
            },
            searchByEnter(e) {
                //엔터 쳤을 때
                if (e.keyCode === 13) this.searchByKeyword();
            },
            searchByKeyword() {
                // 실제 키워드로 검색
                const keyword = this.$refs.searchInput.value;
                /*if (keyword && keyword.trim() !== '') {
                window.location.href = `/search?keyword=${encodeURIComponent(keyword)}`;
            }*/
            },
            toggleActiveMenu() {
                this.isActiveMenu = !this.isActiveMenu;
            },
            setInActiveMenu() {
                this.isActiveMenu = false;
            },
        },
        created() {
            setTimeout(() => this.toggleInit(), 100);
        },
    };
</script>
<style lang="scss" scoped>
    .logobar {
        min-height: 68px;
        position: relative;
        z-index: 1;

        .container {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 20px 0 4px 0;

            .logo {
                img {
                    margin: 0;
                    padding: 0;
                    vertical-align: middle;
                    height: 51px;
                }
                img:has(+ img) {
                    height: 31px;
                    margin-top: 20px;
                    margin-right: 6px;
                }
                img + img {
                    height: 51px;
                }
            }

            .search-field {
                position: relative;

                input {
                    width: 280px;
                    height: 34px;
                    padding: 8px 10px;
                    align-items: center;
                    border: 1px solid #e5e5e5;
                    background: #f8f8f8;
                    box-sizing: border-box;

                    font-size: 14px;
                    font-style: normal;

                    line-height: normal;
                    color: rgba(0, 0, 0, 0.87);

                    &::placeholder {
                        color: #c8c8c8;
                    }
                }

                img {
                    position: absolute;
                    top: 50%;
                    right: 10px;
                    transform: translateY(-50%);
                    cursor: pointer;
                }
            }
        }
    }

    .print-options {
        width: 300px;
        padding: 0;
        margin: 0;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        margin-top: 1rem;
        background-color: #f5f5f5;
        transition: all 0.3s ease;
    }

    .print-options button {
        margin: 0;
        padding: 0.5rem 1rem;
        color: #000;
        cursor: pointer;
        border-radius: 20px;
        background-color: #f5f5f5;
        transition: all 0.3s ease;
        width: 100px;
    }

    .print-options button.active {
        border-radius: 20px;
        background-color: #000;
        color: #fff;
        border-color: #000;
        transition: all 0.3s ease;
        width: 100px;
    }

    .mobile-field-ul {
        display: none;
    }

    .mobile-menu {
        position: fixed;
        display: none;
        top: 78px;
        left: 0;
        right: 0;
        bottom: 0;
        background: #fff;
        border-top: 1px solid #e5e5e5;
        flex-direction: column;

        ul {
            margin: 0;
            padding: 0;
            list-style: none;
        }

        nav {
            ul {
                display: flex;
                align-items: center;
                padding-left: 11px;
                height: 37px;
            }
        }

        .menu-wrapper {
            flex: 1;
            display: flex;
            align-items: stretch;

            .menu-list1 {
                width: 150px;

                li {
                    line-height: 40px;

                    font-size: 14px;
                    padding-left: 16px;
                    cursor: pointer;

                    &:hover,
                    &.active {
                        background: #f7f7f7;
                        font-weight: 500;
                    }
                }
            }
            .menu-list2 {
                width: 150px;
                flex: 1;
                background: #f7f7f7;
                padding-top: 10px;

                li {
                    line-height: 20px;
                    margin-bottom: 4px;
                    padding-left: 30px;

                    &:last-of-type {
                        margin-bottom: 0;
                    }

                    a {
                        font-size: 14px;
                        line-height: 100%;
                        color: #000;

                        &:hover {
                            font-weight: 500;
                        }
                    }

                    i {
                        width: 12px;
                        height: 12px;
                        border-radius: 50%;
                        align-items: center;
                        justify-content: center;

                        vertical-align: middle;

                        color: #fff;
                        font-size: 7px;

                        font-style: normal;
                        display: none;
                        position: relative;
                        top: -1px;

                        &.h-icon {
                            background: #c20000;
                        }
                        &.n-icon {
                            background: #3e7af2;
                        }
                        &.b-icon {
                            background: #127017;
                        }
                    }

                    &.h {
                        i.h-icon {
                            display: inline-flex;
                        }
                    }
                    &.n {
                        i.n-icon {
                            display: inline-flex;
                        }
                    }
                    &.b {
                        i.b-icon {
                            display: inline-flex;
                        }
                    }
                }
            }
        }
    }
</style>
